import { MinimumStationsGroup, Station, StationType } from '@mi-front/core';
import { Field, FieldProps } from 'formik';
import { StationsAdvancedFilter } from '../StationsAdvancedFilter';

export interface StationsAdvancedFilterFieldFormikProps {
  name: string;
  label?: string;
  placeholder?: string;
  multiple?: boolean;
  stations?: Station[];
  stationGroups?: MinimumStationsGroup[];
  allowedStationTypes?: StationType[];
  disabled?: boolean;
}

export function StationsAdvancedFilterFieldFormik({
  name,
  label,
  placeholder,
  multiple = true,
  stations,
  stationGroups,
  allowedStationTypes,
  disabled,
}: StationsAdvancedFilterFieldFormikProps): JSX.Element {
  return (
    <Field name={name}>
      {(fieldProps: FieldProps) => {
        const { field, meta } = fieldProps;

        return (
          <StationsAdvancedFilter
            stations={stations || []}
            stationGroups={stationGroups || []}
            allowedStationTypes={allowedStationTypes}
            value={field.value || []}
            onChange={(selectedOptions) => {
              field.onChange({
                target: {
                  name: field.name,
                  value: selectedOptions,
                },
              });
            }}
            multiple={multiple}
            label={label}
            placeholder={placeholder}
            disabled={disabled}
            error={!!(meta.touched && meta.error)}
            helperText={meta.touched && meta.error ? meta.error : undefined}
          />
        );
      }}
    </Field>
  );
}
